import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { ConsoleBufferService } from './app/core/services/console-buffer.service';
import { PlaybackJournal } from './app/core/services/playback-journal';

// Capture console output / uncaught errors from the very start, before Angular boots.
ConsoleBufferService.install();
// Mirror console + playback health to the backend, so unreported stalls leave evidence.
PlaybackJournal.install();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
